<template>
  <div v-if="menu && menuItems">
    <XsMenu
      v-if="$vuetify.breakpoint.xsOnly"
      :menu="menu"
      :menuItems="menuItems"
    />
    <Menu v-else :menu="menu" :menuItems="menuItems" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Menu from "@/components/Menu/Menu.vue";
import XsMenu from "@/components/Menu/Xs/Menu.vue";

export default {
  name: "MenuView",
  components: { Menu, XsMenu },
  computed: {
    ...mapGetters("menu", { menuItems: "bySection" }),
    ...mapState({
      menu: (state) =>
        state.departments.data.find((dept) => dept.category_id === "Menu"),
    }),
  },
};
</script>
